import React from 'react';
import './group-figures.css';

const GroupFigures = (props) => {
	const {shape} = props;
	return (
		<svg className={`group-figures group-figures--${shape}`}
		     xmlns="http://www.w3.org/2000/svg"
		     xmlnsXlink="http://www.w3.org/1999/xlink"
		     viewBox="0 0 322.39 197.46">
			<defs>
				<clipPath id="a" transform="translate(0 0)">
					<rect width="322.39" height="197.46" fill="none"/>
				</clipPath>
			</defs>
			<g className='group-figures__plus'>
				<line x1="206.06" y1="124.99" x2="190.81" y2="110.69" fill="none" stroke="#1b65e6" strokeLinecap="round"
				      strokeLinejoin="round" strokeWidth="5"/>
				<line x1="191.28" y1="125.47" x2="205.59" y2="110.21" fill="none" stroke="#1b65e6" strokeLinecap="round"
				      strokeLinejoin="round" strokeWidth="5"/>
			</g>
			<g className='group-figures__triangles'>
				<polygon points="154.75 52.49 144.25 34.33 133.78 52.5 123.31 70.67 144.28 70.66 165.25 70.65 154.75 52.49"
				         fill="none" stroke="#1b65e6" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5"/>
				<polygon points="177.57 65.85 167.07 47.69 156.6 65.86 146.12 84.03 167.09 84.02 188.07 84 177.57 65.85"
				         fill="none" stroke="#1b65e6" strokeMiterlimit="10"/>
			</g>
			<g clipPath="url(#a)">
				<g className='group-figures__semicircle'>
					<path d="M76.89,143.9a15.91,15.91,0,0,1,31.83,0" transform="translate(0 0)" fill="none" stroke="#1b65e6"
					      strokeLinecap="round" strokeLinejoin="round" strokeWidth="5"/>
					<path d="M99.7,157.26a15.91,15.91,0,0,1,31.83,0" transform="translate(0 0)" fill="none" stroke="#1b65e6"
					      strokeMiterlimit="10"/>
				</g>
				<g className='group-figures__circles-top'>
					<circle cx="283.16" cy="18.41" r="15.91" fill="none" stroke="#1b65e6" strokeLinecap="round"
					        strokeLinejoin="round" strokeWidth="5"/>
					<circle cx="305.98" cy="31.77" r="15.91" fill="none" stroke="#1b65e6" strokeMiterlimit="10"/>
				</g>
				<g className='group-figures__rectangle'>
					<rect x="255.06" y="135.94" width="31.65" height="31.65" fill="none" stroke="#1b65e6" strokeLinecap="round"
					      strokeLinejoin="round" strokeWidth="5"/>
				</g>
				<g className='group-figures__wave'>
					<path d="M161.09,179.94c-6.91,0-5.72-12.26-14.54-12.26" transform="translate(0 0)" fill="none"
					      stroke="#1b65e6"
					      strokeLinecap="round" strokeLinejoin="round" strokeWidth="5"/>
					<path d="M190.16,179.94c-6.91,0-5.72-12.25-14.54-12.25" transform="translate(0 0)" fill="none"
					      stroke="#1b65e6"
					      strokeLinecap="round" strokeLinejoin="round" strokeWidth="5"/>
					<path d="M161.09,179.94c6.91,0,5.72-12.25,14.54-12.25" transform="translate(0 0)" fill="none" stroke="#1b65e6"
					      strokeLinecap="round" strokeLinejoin="round" strokeWidth="5"/>
					<path d="M190.16,179.94c6.91,0,5.72-12.26,14.53-12.25" transform="translate(0 0)" fill="none" stroke="#1b65e6"
					      strokeLinecap="round" strokeLinejoin="round" strokeWidth="5"/>
				</g>
				<path d="M233.17,67c0,6.91-12.25,5.72-12.25,14.54" transform="translate(0 0)" fill="none" stroke="#1b65e6"
				      strokeLinecap="round" strokeLinejoin="round" strokeWidth="5"/>
				<path d="M233.17,38c0,6.91-12.25,5.72-12.25,14.54" transform="translate(0 0)" fill="none" stroke="#1b65e6"
				      strokeLinecap="round" strokeLinejoin="round" strokeWidth="5"/>
				<path d="M233.17,67c0-6.91-12.25-5.72-12.25-14.54" transform="translate(0 0)" fill="none" stroke="#1b65e6"
				      strokeLinecap="round" strokeLinejoin="round" strokeWidth="5"/>
				<g className='group-figures__circles-bottom'>
					<circle cx="41.23" cy="181.04" r="15.91" fill="none" stroke="#1b65e6" strokeMiterlimit="10"/>
					<circle cx="18.41" cy="167.68" r="15.91" fill="none" stroke="#1b65e6" strokeLinecap="round"
					        strokeLinejoin="round" strokeWidth="5"/>
				</g>
				<rect x="277.88" y="149.3" width="31.65" height="31.65" fill="none" stroke="#1b65e6" strokeMiterlimit="10"/>
				<path d="M183.9,193.3c-6.91,0-5.72-12.26-14.54-12.26" transform="translate(0 0)" fill="none" stroke="#1b65e6"
				      strokeMiterlimit="10"/>
				<path d="M213,193.3c-6.91,0-5.72-12.25-14.54-12.25" transform="translate(0 0)" fill="none" stroke="#1b65e6"
				      strokeMiterlimit="10"/>
				<path d="M183.9,193.3c6.91,0,5.72-12.25,14.54-12.25" transform="translate(0 0)" fill="none" stroke="#1b65e6"
				      strokeMiterlimit="10"/>
				<path d="M213,193.3c6.91,0,5.72-12.26,14.53-12.25" transform="translate(0 0)" fill="none" stroke="#1b65e6"
				      strokeMiterlimit="10"/>
				<path d="M256,80.39c0,6.91-12.25,5.72-12.25,14.54" transform="translate(0 0)" fill="none" stroke="#1b65e6"
				      strokeMiterlimit="10"/>
				<path d="M256,51.32c0,6.91-12.25,5.72-12.25,14.54" transform="translate(0 0)" fill="none" stroke="#1b65e6"
				      strokeMiterlimit="10"/>
				<path d="M256,80.39c0-6.91-12.25-5.72-12.25-14.54" transform="translate(0 0)" fill="none" stroke="#1b65e6"
				      strokeMiterlimit="10"/>
				<path d="M256,51.32c0-6.91-12.25-5.72-12.25-14.53" transform="translate(0 0)" fill="none" stroke="#1b65e6"
				      strokeMiterlimit="10"/>
				<line x1="18.39" y1="111.67" x2="43.76" y2="86.31" fill="none" stroke="#1b65e6" strokeMiterlimit="10"/>
				<path className='group-figures__circle-bold'
				      d="M87.06,69.25a6.27,6.27,0,1,1,2-8.64A6.26,6.26,0,0,1,87.06,69.25Z" transform="translate(0 0)"
				      fill="none" stroke="#1b65e6" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5"/>
			</g>
		</svg>
	);
};

export default GroupFigures;



// WEBPACK FOOTER //
// ./src/components/GroupFigures/GroupFigures.js